import get from 'lodash/get';
import isFunction from 'lodash/isFunction';
import isEmpty from 'lodash/isEmpty';

const xmlHttpRequestWrapper = ({
    method,
    url,
    data,
    headers,
    onUploadProgress
}) => {
    const promise = new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        if (isFunction(onUploadProgress)) {
            xhr.upload.onprogress = progressEvent => {
                onUploadProgress(progressEvent);
            };
        }
        xhr.onload = () => {
            if (get(xhr, 'status') >= 400) {
                reject(get(xhr, 'response', {}));
            } else {
                resolve(get(xhr, 'response', {}));
            }
        };
        xhr.onerror = () => {
            reject({});
        };

        xhr.open(method, url);
        xhr.setRequestHeader('Content-Type', 'application/json');
        if (!isEmpty(headers)) {
            const headersKeys = Object.keys(headers);
            for (let i = 0; i < headersKeys.length; i++) {
                xhr.setRequestHeader(headersKeys[i], headers[headersKeys[i]]);
            }
        }
        xhr.send(data);
    });
    return promise;
};

export default xmlHttpRequestWrapper;
